/** Optional reads must not block public pages. Auth writes are checked explicitly. */
const safeStorage = name => ({
  getItem(key) { try { return window[name].getItem(key); } catch { return null; } },
  setItem(key, value) { try { window[name].setItem(key, value); return true; } catch { return false; } },
  removeItem(key) { try { window[name].removeItem(key); return true; } catch { return false; } },
  keys() { try { return Object.keys(window[name]); } catch { return []; } },
});
export const safeLocalStorage = safeStorage('localStorage');
export const safeSessionStorage = safeStorage('sessionStorage');
export function sessionStorageError() {
  const error = new Error('Il browser blocca lo spazio necessario alla sessione. Consenti i dati del sito per accedere o registrarti.');
  error.code = 'STORAGE_UNAVAILABLE';
  return error;
}
export function assertSessionStorage() {
  const key = `session-check-${crypto.randomUUID()}`;
  const value = 'available';
  const written = safeLocalStorage.setItem(key, value);
  const readable = safeLocalStorage.getItem(key) === value;
  safeLocalStorage.removeItem(key);
  if (!written || !readable) throw sessionStorageError();
}